import { ITaskListHeaderParams } from 'src/app/models/domain/task-list-header-params';

export class TaskListHeader {
  public readonly id: string;

  public readonly taskListType: string;
  public readonly changeNumber: string;
  public readonly taskListGroup: string;
  public readonly groupCounter: string;
  public readonly inactive: boolean;
  public readonly counter: string;
  public readonly createdBy: string;
  public readonly usage: string;
  public readonly description: string;
  public readonly changedBy: string;
  public readonly usageDescription: string;
  public readonly plant: string;
  public readonly status: string;
  public readonly changedOn?: Date;
  public readonly createdOn?: Date;
  public readonly validFrom?: Date;

  public constructor(params: ITaskListHeaderParams) {
    this.taskListType = params.taskListType;
    this.changeNumber = params.changeNumber;
    this.taskListGroup = params.taskListGroup;
    this.groupCounter = params.groupCounter;
    this.inactive = params.inactive;
    this.counter = params.counter;
    this.createdBy = params.createdBy;
    this.usage = params.usage;
    this.description = params.description;
    this.changedBy = params.changedBy;
    this.usageDescription = params.usageDescription;
    this.plant = params.plant;
    this.status = params.status;
    this.changedOn = params.changedOn;
    this.createdOn = params.createdOn;
    this.validFrom = params.validFrom;

    this.id = `${params.taskListType}-${params.taskListGroup}-${params.groupCounter}`;
  }
}
